import { formatMoney } from "@/lib/money";

const Stat = ({ label, value, accent }) => (
  <div className="rounded-xl border border-border bg-background p-4" data-testid={`truffl-stat-${label.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
    <div className="text-[10px] uppercase tracking-[0.2em] text-muted-foreground">{label}</div>
    <div className={`mt-1 font-display text-xl ${accent ? "text-emerald-600" : ""}`}>{value}</div>
  </div>
);

export const AnalyticsTab = ({ analytics }) => {
  if (!analytics) return <p className="text-sm text-muted-foreground">Loading analytics…</p>;
  const a = analytics;
  const maxRev = Math.max(1, ...(a.monthly_trend || []).map((m) => m.revenue));

  return (
    <div className="space-y-6" data-testid="truffl-analytics">
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-4">
        <Stat label="Revenue Generated" value={formatMoney(a.revenue || 0)} accent />
        <Stat label="Clients Won" value={a.clients_won || 0} />
        <Stat label="Win Rate" value={`${a.win_rate || 0}%`} />
        <Stat label="Avg Deal Size" value={a.avg_deal_size ? formatMoney(a.avg_deal_size) : "—"} />
      </div>
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-4">
        <Stat label="Leads Discovered" value={a.total_leads || 0} />
        <Stat label="Missions Created" value={a.missions_created || 0} />
        <Stat label="Outreach Sent" value={a.outreach_sent || 0} />
        <Stat label="Meetings Booked" value={a.meetings_booked || 0} />
      </div>
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-4">
        <Stat label="Proposals Sent" value={a.proposals_sent || 0} />
        <Stat label="Pipeline Value" value={formatMoney(a.pipeline_value || 0)} />
        <Stat label="Best City" value={a.best_city || "—"} />
        <Stat label="Best Industry" value={a.best_industry || "—"} />
      </div>

      <div className="rounded-2xl border border-border bg-card p-6">
        <h4 className="font-display text-lg">Monthly revenue trend</h4>
        {(a.monthly_trend || []).length === 0 ? (
          <p className="mt-3 text-sm text-muted-foreground">Win your first client to start the trend line.</p>
        ) : (
          <div className="mt-5 flex h-40 items-end gap-4" data-testid="truffl-trend-chart">
            {a.monthly_trend.map((m) => (
              <div key={m.month} className="flex flex-1 flex-col items-center gap-1.5">
                <span className="text-xs text-emerald-600">{formatMoney(m.revenue)}</span>
                <div className="w-full max-w-[64px] rounded-t-lg bg-gradient-to-t from-emerald-500 to-accent"
                  style={{ height: `${Math.max(12, (m.revenue / maxRev) * 110)}px` }} />
                <span className="text-[10px] text-muted-foreground">{m.month}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
